import React, { useState } from 'react';
import { connect } from 'react-redux';

import {
		setSelectedSchool as setSelectedSchoolAction,
} from '../actions'

import Logo from '../components/Logo';
import Search from '../components/Search';
import Table from '../components/Table';
import Footer from '../components/Footer';

import CloseImage from '../../img/close.svg';

import "../../css/Home.css";
import HomeBox from '../components/HomeBox';


const Home = ({ onSchoolSelect }) => {

	const [searchTerm, setSearchTerm] = useState("");
	const [helpShown, setHelpShown] = useState(false);

	const HOME_BOXES = [
		{
			type: "help",
			children: "What is This?",
			onClick: () => setHelpShown(true)
		},
		{
			type: "donate",
			children: "Buy me a Coffee!",
			onClick: () => window.open("https://ko-fi.com/fullmeter", '_blank')
		}
	]
	

	const isSearched = searchTerm => item => {
		const lowercaseSearch = searchTerm.toLowerCase();
		return [item.rollNumber, item.schoolName, item.addressOne, item.addressTwo, item.addressThree, item.addressFour].some(str => str.toLowerCase().includes(lowercaseSearch));
	}

	return (
		<div>

			<Logo 
				onClick={() => {setSearchTerm(""); setHelpShown(false)}}
				showRetry={searchTerm}
			>SET Cluster Finder</Logo>

			<Search
				value={searchTerm}
				onChange={e => {setSearchTerm(e.target.value); searchTerm.length > 1 && setHelpShown(false)}}
				placeholder="Type your school's roll/name/address..."
			/>
			{searchTerm.length > 2 ?
				<Table 
					pattern={searchTerm}
					onRowSelect={onSchoolSelect}
					isSearched={isSearched}
				/>
			: helpShown ?
				<div id="appExplainer">
					<header>
						<h1>How does it work?</h1>
						<img src={CloseImage} alt="close" onClick={() => setHelpShown(false)}/>
					</header>
					
					<section>
						<p>- Search for your school in the bar above and select it</p>
						<p>- Recommended mode uses your school's leftover DES allocated hours. Custom mode allows you to search for a cluster of any size. If you're not sure, use recommended</p>
						<p>- <b>SET Cluster Finder</b> will find every school within a 1km radius of your school. It will then check if <span style={{color: "red"}}>any combination of those schools' leftover SET allocation hours</span> + <span style={{color: "var(--blue)"}}>your school's leftover SET allocation hours</span> = <span style={{color: "#dd12dd"}}>25</span></p>
						<p>- If it finds a matching cluster, <b>SET Cluster Finder</b> will show you the details of the schools you need to contact. It always prioritises schools that are closer to you</p>
						<p>- If it fails to find a match, it will increase the search radius to 2km. Then 3km. All the way up to 50km. This can take a while, <em>especially if you have very few leftover hours</em></p>
						<p>- If for whatever reason <b>SET Cluster Finder</b> offers you a school you can't pair up with, you can remove it from the results and try again</p>
					</section>
				</div>
			:
			<div id="HomeBoxContainer">
				{HOME_BOXES.map(boxData => 
					<HomeBox
						key={`${boxData.type}-homebox`}
						type={boxData.type}
						children={boxData.children}
						onClick={boxData.onClick}
					></HomeBox>
				)}
					
				</div>

			}
				

			{searchTerm.length < 3 && !helpShown &&
				<Footer isFixed={true}/>
			}
		</div>
	)
}

const mapStateToProps = state => ({
		selectedSchoolIndex: state.selectedSchoolIndexState
})


const mapDispatchToProps = dispatch => ({
	onSchoolSelect: schoolIndex => dispatch(setSelectedSchoolAction(schoolIndex)),
})

export default connect(
	mapStateToProps, 
	mapDispatchToProps,
)(Home);
